import type { GeneratedWindowPlacement } from "building-types/windows/windowTypes";
import type { Table } from "common/data/table";

export function windowPlacementsOnLevel(
  levelId: string,
  windowPlacements: Table<GeneratedWindowPlacement>,
): GeneratedWindowPlacement[] {
  const a: GeneratedWindowPlacement[] = [];

  for (const id in windowPlacements) {
    const window = windowPlacements[id];
    if (window?.frontRoom?.level.id === levelId) {
      a.push(window);
    } else if (!window) {
      console.assert(false, `null window ${id}`);
    }
  }

  return a;
}
